// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination--L5HJG","active":"active--vBeDB","paginationDark":"paginationDark--lA4Ib","paginationLeft":"paginationLeft--c5zG0"};